import { useContext, useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import moment from 'moment-timezone';
import { TranslationContext } from '../../../assets/contexts/translationContext';
import { UserContext } from '../../../assets/contexts/userContext';
import AuthFormWrapper from '../AuthFormWrapper/AuthFormWrapper';
import './RegisterOneMoreStep.css';
import AuthInput from '../AuthInput/AuthInput';
import {
  AGE_VERIFIED,
  AUTH_POPUP_TYPE,
  AUTH_SIGNUP_ONE_MORE_STEP_TYPE,
} from '../../../assets/utils/constants';
import { DateIcon } from '../../../assets/icons/icons';
import useAutoDismissError from '../../../assets/hooks/useAutoDismissError';
import useParseApiError from '../../../assets/hooks/useParseApiError';
import { PopupContext } from '../../../assets/contexts/popupContex';
import mainApi from '../../../assets/api/MainApi';

const initialValues = {
  date: '',
};

const initialValuesValidity = {
  date: { validState: false, errorMessage: '' },
};

function RegisterOneMoreStep() {
  const {
    auth: {
      registerOneMoreStep: { title, subtitle, buttonText },
    },
    labels: { dateOfBirth },
    errors: { fieldRequired, invalidDateValue, invalidDateMin, invalidDateMax },
    helmet: { description, registerOneMoreStepTitle },
  } = useContext(TranslationContext);
  const { setUser } = useContext(UserContext);
  const { handlePopupClose } = useContext(PopupContext);
  const [values, setValues] = useState(initialValues);
  const [valuesValidity, setValuesValidity] = useState(initialValuesValidity);
  const [isFormValid, setIsFormValid] = useState(false);
  const [isPreloader, setIsPreloader] = useState(false);
  const date_now = moment();
  const max_date = moment().subtract(18, 'years');
  const min_date = moment('1900-01-01', 'YYYY-MM-DD');
  const [error, showError] = useAutoDismissError();
  const { parseApiError } = useParseApiError();

  useEffect(() => {
    setIsFormValid(
      Object.values(valuesValidity).every(({ validState }) => validState)
    );
  }, [valuesValidity]);

  function handleChange(e) {
    const { name, value } = e.target;

    const selected_date = moment(value);

    setValues((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
    if (!value) {
      setValuesValidity((prevValue) => ({
        ...prevValue,
        [name]: { errorMessage: fieldRequired, validState: false },
      }));
    } else {
      setValuesValidity((prevValue) => ({
        ...prevValue,
        [name]: selected_date.isValid()
          ? selected_date.diff(date_now, 'seconds') >= 10
            ? {
                errorMessage: invalidDateValue,
                validState: false,
              }
            : selected_date.diff(max_date, 'seconds') <= 10
            ? selected_date.diff(min_date, 'seconds') >= 10
              ? {
                  errorMessage: '',
                  validState: true,
                }
              : {
                  errorMessage: invalidDateMin,
                  validState: false,
                }
            : {
                errorMessage: invalidDateMax,
                validState: false,
              }
          : {
              errorMessage: invalidDateValue,
              validState: false,
            },
      }));
    }
  }

  function handleSubmit(e) {
    e.preventDefault();
    setIsPreloader(true);
    mainApi
      .editPersonalData({
        name: null,
        date_of_birth: values.date,
        avatar: null,
        unset_avatar: false,
      })
      .then((res) => {
        setUser(res);
        localStorage.setItem(AGE_VERIFIED, true);
        handlePopupClose(AUTH_POPUP_TYPE);
      })
      .catch((err) => {
        showError(parseApiError(err));
      })
      .finally(() => {
        setIsPreloader(false);
      });
  }

  return (
    <>
      <Helmet>
        <title>{registerOneMoreStepTitle}</title>
        <meta name="description" content={description} />
      </Helmet>

      <AuthFormWrapper
        title={title}
        subtitle={subtitle}
        buttonText={buttonText}
        id={AUTH_SIGNUP_ONE_MORE_STEP_TYPE}
        onSubmit={handleSubmit}
        isFormValid={isFormValid}
        isPreloader={isPreloader}
        error={error}
      >
        <AuthInput
          label={dateOfBirth}
          name="date"
          type="date"
          inputMode="numeric"
          autoComplete="bday"
          max={moment().format('YYYY-MM-DD')}
          value={values.date}
          onChange={handleChange}
          error={valuesValidity.date}
          icon={DateIcon}
        />
      </AuthFormWrapper>
    </>
  );
}

export default RegisterOneMoreStep;
